<script setup lang="ts">
/**
 * Chrome around one entry in a repeatable list (stats, cards, FAQs, logos,
 * team members, jobs): bordered box, numbered label, remove button.
 */
defineProps<{ label: string }>()

defineEmits<{ remove: [] }>()
</script>

<template>
  <div class="space-y-2 rounded-lg border border-default p-2.5">
    <div class="flex items-center justify-between">
      <p class="text-xs font-medium text-muted">
        {{ label }}
      </p>
      <UButton
        size="xs"
        variant="ghost"
        color="error"
        icon="i-lucide-x"
        @click="$emit('remove')"
      />
    </div>
    <slot />
  </div>
</template>
